"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("el-dialog", {
    attrs: {
      title: "Bulk Upload Payment",
      visible: _vm.visible,
      width: "1150px",
      "close-on-click-modal": false
    },
    on: {
      close: _vm.handleClose
    }
  }, [!_vm.rows.length ? _c("div", [_c("el-alert", {
    attrs: {
      title: "Your Excel file must contain the following column names exactly as written (first sheet, first row as header).",
      type: "info",
      closable: false,
      "show-icon": ""
    }
  }), _c("el-table", {
    staticStyle: {
      width: "100%",
      "margin-top": "15px"
    },
    attrs: {
      data: _vm.columns,
      border: "",
      size: "mini"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "name",
      label: "Column Name",
      width: "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("code", [_vm._v(_vm._s(scope.row.name))])];
      }
    }], null, false, 370914816)
  }), _c("el-table-column", {
    attrs: {
      label: "Mandatory",
      width: "100",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tag", {
          attrs: {
            type: scope.row.mandatory ? "danger" : "info",
            size: "mini"
          }
        }, [_vm._v(" " + _vm._s(scope.row.mandatory ? "Yes" : "No") + " ")])];
      }
    }], null, false, 1715392419)
  }), _c("el-table-column", {
    attrs: {
      prop: "description",
      label: "Description",
      "min-width": "320"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "example",
      label: "Example",
      width: "220"
    }
  })], 1), _c("ul", {
    staticClass: "notes"
  }, [_c("li", [_vm._v("Every row is added as a "), _c("b", [_vm._v("pending Payment")]), _vm._v(" that must be approved afterwards, exactly like adding a payment manually.")]), _c("li", [_c("code", [_vm._v("dealerId")]), _vm._v(" is used to match the dealer. "), _c("code", [_vm._v("dealerName")]), _vm._v(" is for your reference only.")]), _c("li", [_vm._v("Format the "), _c("code", [_vm._v("paymentDate")]), _vm._v(" column as "), _c("b", [_vm._v("Text")]), _vm._v(" and enter DD/MM/YYYY. Excel date-formatted cells are rejected to avoid day/month swaps.")]), _c("li", [_vm._v("A payment whose "), _c("code", [_vm._v("transactionReference")]), _vm._v(" already exists for the same dealer will be rejected.")])]), _c("div", {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "warning",
      icon: "el-icon-upload2"
    },
    on: {
      click: _vm.pickFile
    }
  }, [_vm._v(" Select Excel File ")]), _c("el-button", {
    attrs: {
      size: "mini",
      icon: "el-icon-download"
    },
    on: {
      click: _vm.downloadTemplate
    }
  }, [_vm._v(" Download Template ")]), _c("span", {
    staticClass: "el-upload__tip"
  }, [_vm._v("  Only .xlsx / .xls files are allowed")])], 1), _c("el-upload", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "uploadRef",
    attrs: {
      action: "",
      "auto-upload": false,
      limit: 1,
      accept: ".xlsx,.xls",
      "on-change": _vm.handleFileChange,
      "on-exceed": _vm.handleExceed
    }
  })], 1) : _c("div", [_c("h3", {
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v(" Data Preview (" + _vm._s(_vm.rows.length) + " rows · " + _vm._s(_vm.pendingCount) + " ready · " + _vm._s(_vm.successCount) + " uploaded · " + _vm._s(_vm.failedCount) + " failed) ")]), _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.rows,
      border: "",
      size: "mini",
      "max-height": "420"
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "#",
      type: "index",
      width: "45",
      index: i => i + 2
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Status",
      width: "150",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.__status === "success" ? _c("el-tag", {
          attrs: {
            type: "success",
            size: "mini"
          }
        }, [_c("i", {
          staticClass: "el-icon-check"
        }), _vm._v(" Uploaded ")]) : scope.row.__status === "uploading" ? _c("el-tag", {
          attrs: {
            type: "warning",
            size: "mini"
          }
        }, [_c("i", {
          staticClass: "el-icon-loading"
        }), _vm._v(" Uploading ")]) : scope.row.__status === "invalid" ? _c("el-tag", {
          attrs: {
            type: "danger",
            size: "mini"
          }
        }, [_vm._v(" Invalid ")]) : scope.row.__status === "error" ? _c("el-tag", {
          attrs: {
            type: "danger",
            size: "mini"
          }
        }, [_c("i", {
          staticClass: "el-icon-close"
        }), _vm._v(" Failed ")]) : _c("el-tag", {
          attrs: {
            type: "info",
            size: "mini"
          }
        }, [_vm._v(" Pending ")]), scope.row.__error ? _c("div", {
          staticClass: "row-error-text"
        }, [_vm._v(" " + _vm._s(scope.row.__error) + " ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "dealerId",
      label: "Dealer ID",
      "min-width": "80"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "dealerName",
      label: "Dealer Name",
      "min-width": "140"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "amount",
      label: "Amount",
      "min-width": "90"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "paymentDate",
      label: "Payment Date",
      "min-width": "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "paymentType",
      label: "Payment Type",
      "min-width": "110"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "paymentMode",
      label: "Mode",
      "min-width": "70"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "transactionReference",
      label: "Reference",
      "min-width": "130"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "bank",
      label: "Bank",
      "min-width": "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "narration",
      label: "Narration",
      "min-width": "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "createdBy",
      label: "Created By",
      "min-width": "80"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Action",
      width: "90",
      align: "center",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button", {
          attrs: {
            size: "mini",
            type: "primary",
            disabled: !_vm.canUpload(scope.row) || _vm.uploadingAll
          },
          on: {
            click: function ($event) {
              return _vm.uploadOne(scope.row);
            }
          }
        }, [_vm._v(" Upload ")])];
      }
    }])
  })], 1)], 1), _vm.rows.length ? _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      disabled: _vm.uploadingAll
    },
    on: {
      click: _vm.reset
    }
  }, [_vm._v("Choose Another File")]), _c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.uploadingAll,
      disabled: !_vm.uploadableRows.length
    },
    on: {
      click: _vm.uploadAll
    }
  }, [_vm._v(" Upload All (" + _vm._s(_vm.uploadableRows.length) + ") ")])], 1) : _vm._e()]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;